import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Radio, Dropdown, Select } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { CaptureSVG } from '../CaptureSVG';
import { ActionFooter } from '../components/ActionFooter';
import '../styles.css';

export function FormScreen({
  captureKey,
  email,
  transactionType,
  endToEndId,
  primaryColor,
  handleEmailChange,
  handleTransactionTypeChange,
  handleEndToEndIdChange,
  menuItems,
  captureType,
  handleMenuClick,
  startNewCapture,
  formButtonDisabled,
}) {
  const intl = useIntl();
  const containerRef = useRef(null);
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    const checkElementWidth = () => {
      if (containerRef.current) {
        setIsNarrow(containerRef.current.offsetWidth <= 330);
      }
    };

    checkElementWidth();

    const resizeObserver = new ResizeObserver(checkElementWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  const transactionTypeOptions = [
    { value: 'verification', label: intl.formatMessage({ id: 'verification' }) },
    { value: 'onboarding', label: intl.formatMessage({ id: 'onboarding' }) },
    { value: 'id_capture', label: intl.formatMessage({ id: 'id_capture' }) },
  ];

  return (
    <>
      <div ref={containerRef} className="overflow-x-hidden overflow-y-auto">
        <div className="flex items-center justify-center sm:w-72 w-full mx-auto">
          <CaptureSVG color={primaryColor} />
        </div>
        <Form
          layout="vertical"
          className="gap-5"
        >
          <Form.Item
            required
            label={<FormattedMessage id="capture_key" />}
          >
            <Input
              size="large"
              value={captureKey}
              disabled
            />
          </Form.Item>
          <Form.Item
            required
            label={<FormattedMessage id="identifier" />}
          >
            <Input
              size="large"
              value={email}
              onChange={e => handleEmailChange(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            required
            label={<FormattedMessage id="transaction_type" />}
          >
            {isNarrow ? (
              <Select
                size="large"
                value={transactionType}
                onChange={handleTransactionTypeChange}
                options={transactionTypeOptions}
              />
            ) : (
              <Radio.Group
                size="large"
                value={transactionType}
                onChange={e => handleTransactionTypeChange(e.target.value)}
                buttonStyle="solid"
                className="flex flex-row"
              >
                <Radio.Button
                  className="flex-1 text-center"
                  value="verification"
                >
                  <div className="flex justify-center">
                    <FormattedMessage id={'verification'} />
                  </div>
                </Radio.Button>
                <Radio.Button
                  className="flex-1 text-center"
                  value="onboarding"
                >
                  <div className="flex justify-center">
                    <FormattedMessage id={'onboarding'} />
                  </div>
                </Radio.Button>
                <Radio.Button
                  className="flex-1 text-center"
                  value="id_capture"
                >
                  <div className="flex justify-center truncate">
                    <FormattedMessage id={'id_capture'} />
                  </div>
                </Radio.Button>
              </Radio.Group>
            )}
          </Form.Item>
          <Form.Item
            required
            label="End-to-end ID"
          >
            <Input
              size="large"
              value={endToEndId}
              onChange={e => handleEndToEndIdChange(e.target.value)}
            />
          </Form.Item>
        </Form>
      </div>
      <ActionFooter>
        <Dropdown.Button
          className="rounded-dropdown-button"
          type="primary"
          disabled={formButtonDisabled}
          onClick={startNewCapture}
          menu={{ items: menuItems, onClick: handleMenuClick }}
          trigger={['click']}
          icon={<DownOutlined />}
        >
          <FormattedMessage id={captureType} />
        </Dropdown.Button>
      </ActionFooter>
    </>
  );
}
